import { useBoundStore } from '@/shared/store';
import { useShallow } from 'zustand/shallow';

export const useAuth = () => {
  const { accessToken, profile, permissions, setPermissions, hasPermission } =
    useBoundStore(
      useShallow((state) => ({
        accessToken: state.accessToken,
        profile: state.profile,
        permissions: state.permissions,
        setPermissions: state.setPermissions,
        hasPermission: state.hasPermission,
      })),
    );

  const userRole = profile?.role?.name;
  const userId = profile?.id;

  return {
    isAuthenticated: !!accessToken,
    accessToken,
    profile,
    userRole,
    permissions,
    setPermissions,
    hasPermission,
    userId,
  };
};
